import React from "react";

export function formatAuditDisplayValue(val) {
  if (val === null || val === undefined || val === "")
    return <span className="italic text-[#94A3B8]">empty</span>;
  if (Array.isArray(val))
    return val.length === 0 ? (
      <span className="italic text-[#94A3B8]">none</span>
    ) : (
      val.map((value) => readableValue(value)).join(", ")
    );
  if (typeof val === "boolean") return val ? "Yes" : "No";
  if (typeof val === "object") return readableValue(val);
  return String(val);
}

function readableValue(value, depth = 0) {
  if (value === null || value === undefined) return "empty";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value !== "object") return String(value);
  if (depth >= 3) return "Additional details recorded";
  const entries = Object.entries(value);
  if (!entries.length) return "none";
  const text = entries.slice(0, 12).map(([key, item]) =>
    `${Array.isArray(value) ? "" : `${key.replace(/_/g, " ")}: `}${readableValue(item, depth + 1)}`,
  ).join("; ");
  return entries.length > 12 ? `${text}; more details recorded` : text;
}

export function RelationValueList({
  relationKey,
  value,
  variant,
  formatAuditRelationValue,
}) {
  const formatted = formatAuditRelationValue(relationKey, value);

  if (formatted === null) {
    return (
      <span className="italic text-[#94A3B8]">
        {value === null || value === undefined || value === ""
          ? "empty"
          : "none"}
      </span>
    );
  }

  const cls =
    variant === "from"
      ? "text-[#64748B] line-through decoration-[#94A3B8]"
      : "font-medium text-[#16A34A]";

  if (typeof formatted === "string") {
    return <span className={cls}>{formatted}</span>;
  }

  return (
    <ul className={`list-disc space-y-0.5 pl-4 ${cls}`}>
      {formatted.map((line, index) => (
        <li key={index}>{line}</li>
      ))}
    </ul>
  );
}
